import { render, staticRenderFns } from "./description.vue?vue&type=template&id=85d70f54&class=full-height"
import script from "./description.vue?vue&type=script&lang=js"
export * from "./description.vue?vue&type=script&lang=js"
import style0 from "./description.vue?vue&type=style&index=0&id=85d70f54&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\ita.GroupTravel.Website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85d70f54')) {
      api.createRecord('85d70f54', component.options)
    } else {
      api.reload('85d70f54', component.options)
    }
    module.hot.accept("./description.vue?vue&type=template&id=85d70f54&class=full-height", function () {
      api.rerender('85d70f54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/toursCombine/tcSetting/description.vue"
export default component.exports